// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-436996c1]{color:#c81919}.share--catalog-container[data-v-436996c1]{min-width:33%;position:relative}@media only screen and (max-width: 768px){.share--catalog-container[data-v-436996c1]{width:100% !important}}.share--catalog-container .btn[data-v-436996c1]{position:relative;width:300px}@media only screen and (max-width: 768px){.share--catalog-container .btn[data-v-436996c1]{width:100%}}", ""]);
// Exports
module.exports = exports;
